import React, { useState } from 'react';
import ReactPaginate from 'react-paginate';
import '../../../../assets/css/bootstrap.min.css';
import { Flex, SimpleGrid } from '@chakra-ui/react';
import { ClientCard } from './ClientCard';

function Items({ currentItems = null, deleteItem, editItem, showOptions, showReportBtn, showReportModal }) {
    return (
        <SimpleGrid
            columns={{ base: 1, md: 2, lg: 3, "2xl": 3 }}
            gap='20px'
            mb='20px'>
            {currentItems.map((v, k) => (
                <ClientCard key={k} data={v} deleteFn={deleteItem} editFn={editItem} showOptions={showOptions} showReportBtn={showReportBtn} showReportModal={showReportModal} />
            ))}
        </SimpleGrid>
    );
}

export function Clients({ itemsPerPage = 15, data = [], deleteFn, editFn, showOptions, showReportBtn, showReportModal }) {
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = data.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(data.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % data.length;
        setItemOffset(newOffset);
    };

    return (
        <>
            <Items currentItems={currentItems} deleteItem={deleteFn} editItem={editFn} showOptions={showOptions} showReportBtn={showReportBtn} showReportModal={showReportModal} />

            <Flex justify={'center'} pt={4}>
                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                />
            </Flex>
        </>
    );
}